export enum StorageType {
    Google = "Google",
    Azure = "Azure"
};